(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.kafJumplinks = {
    attach: function (context, settings) {
      if (!$('body', context).length) {
        return;
      }

      // If page loads with fragment, set top offset correctly.
      var fragment = window.location.hash;
      if (fragment.length && $(fragment).length) {
        // SetTimeout with 1ms delay makes it work, for mysterious reasons.
        window.setTimeout(function() {
          var topPadding = parseInt($('body').css('padding-top'), 10) + 10;
          var fixedOffset = $(fragment).offset().top - topPadding;
          $(window).scrollTop(fixedOffset);
        }, 1);
      }

      // Take over handling of internal jumplinks entirely.
      $('a[href^="#"]:not([href="#"],[href="#transcript-show"],[href="#transcript-hide"]):not(.ckeditor-accordion-toggler)').click(function(e) {
        e.preventDefault();
        var fragment = $(this).attr('href');
        var topPadding = parseInt($('body').css('padding-top'), 10) + 10;
        if ($(fragment).length) {
          var fixedOffset = $(fragment).offset().top - topPadding;
          $(window).scrollTop(fixedOffset);
        }
        history.pushState(null, null, fragment);
      });

    },
  };
})(jQuery, Drupal);
